import React from 'react';
import { Button } from 'antd';
import { ExportOutlined } from '@ant-design/icons';
import { CSVLink } from 'react-csv';
import { CsvDelimiter } from '@shared/utils/constants';

type CsvExportProps = {
	data: any[];
	filename: string;
	delimiter?: CsvDelimiter;
	buttonLabel?: string;
};

const CsvExport = ({
	data,
	filename,
	delimiter = CsvDelimiter.Comma,
	buttonLabel = 'Export to CSV',
}: CsvExportProps) => {
	return (
		<CSVLink
			key="export-csv"
			data={data}
			separator={delimiter}
			filename={filename}
		>
			<Button icon={<ExportOutlined />}>
				{buttonLabel}
			</Button>
		</CSVLink>
	);
};

export default CsvExport;